import * as React from 'react';
import {Link} from "react-router-dom";

interface SecondaryButtonProps {
    label: string;
    loading: boolean;
    onClick: (event: any) => void;
}

export const SecondaryButton: React.FC<SecondaryButtonProps> = (props) => {

    return (
            <Link to={'#'}
                  className="channelButton"
                  style={{
                      clear: 'none',
                  }}
                  onClick={(event: any) => props.onClick(event)}>
                {props.label}
            </Link>
    );
};

export default SecondaryButton;
